export default function CheckoutAdventureLoader() {
  return (
    <div className='checkout-page checkout-adventures placeholder-animation'>
      <div className='checkout-wrapper checkout-placeholder'>
        <div className='main-form'>
          <div className='placeholder-title' />
          <div className='placeholder-lead__wrapper shadow-block'>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
          </div>
          <div className='placeholder-title' />
          <div className='placeholder-participants_wrapper shadow-block'>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
          </div>
          <div className='placeholder-title' />
          <div className='placeholder-participants_wrapper shadow-block'>
            <div className='form-row'>
              <div className='input-wrapper' />
              <div className='input-wrapper' />
            </div>
          </div>
        </div>
        <div className='total-price-section'>
          <div className='placeholder-title' />
          <div className='shadow-block'>
            <div className='text-placeholder' />
            <div className='text-placeholder small' />
            <div className='text-placeholder' />
            <div className='text-placeholder' />
            <div className='text-placeholder' />
          </div>
        </div>
      </div>
    </div>
  )
}
